<template>
  <footer class="bg-background pt-10 sm:pt-16 pb-6 sm:pb-8 mt-10 sm:mt-16">
    <!-- Support Modal -->
    <SupportModal ref="supportModal" />
    
    <div class="container mx-auto max-w-6xl">
      <!-- Footer Top Section with Columns -->
      <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
        <!-- Column 1: Logo and Description -->
        <div class="col-span-2 sm:col-span-1 md:col-span-1 mb-4 sm:mb-0">
          <img src="/media/crd_logo/logo2.png" alt="Carddy Logo" class="h-8 sm:h-10 object-contain mb-4" />
        </div>
        
        <!-- Column 2: Quick Links -->
        <div>
          <h3 class="text-white font-medium mb-3 sm:mb-4 text-sm sm:text-base">Быстрые ссылки</h3>
          <ul class="space-y-2">
            <li><a href="/#features" class="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm">О нас</a></li>
            <li><a href="/#pricing" class="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm">Стоимость</a></li>
<!--            <li><a href="/#blog" class="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm">Блог</a></li>-->
            <li><a href="/#faq" class="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm">FAQ</a></li>
          </ul>
        </div>
        
        <!-- Column 3: Legal -->
        <div>
          <h3 class="text-white font-medium mb-3 sm:mb-4 text-sm sm:text-base">Информация</h3>
          <ul class="space-y-2">
            <li><router-link to="/terms" class="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm">Условия использования</router-link></li>
            <li><router-link to="/privacy" class="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm">Политика конфиденциальности</router-link></li>
          </ul>
        </div>
        
        <!-- Column 4: Support -->
        <div>
          <h3 class="text-white font-medium mb-3 sm:mb-4 text-sm sm:text-base">Поддержка</h3>
          <div class="mt-4">
            <button 
              @click="openSupportModal" 
              class="bg-[#09c6f8] text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm inline-block hover:bg-[#08b5e4] transition-colors cursor-pointer"
            >
              Поддержка
            </button>
          </div>
        </div>
      </div>
      
      <!-- Footer Bottom Section -->
      <div class="border-t border-gray-800 pt-6 flex flex-col sm:flex-row justify-between items-center">
        <p class="text-gray-500 text-xs sm:text-sm mb-4 sm:mb-0 text-center sm:text-left">
          &copy; 2025 Carddy. Все права защищены.
        </p>
        <div class="flex space-x-4 items-center">
          <router-link to="/terms" class="text-gray-500 hover:text-white transition-colors text-xs sm:text-sm">Условия</router-link>
          <router-link to="/privacy" class="text-gray-500 hover:text-white transition-colors text-xs sm:text-sm">Конфиденциальность</router-link>
<!--          <a href="#" class="text-gray-500 hover:text-white transition-colors text-xs sm:text-sm">Cookies</a>-->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SupportModal from '@/components/SupportModal.vue'

export default {
  name: 'TheFooter',
  components: {
    SupportModal
  },
  methods: {
    openSupportModal() {
      this.$refs.supportModal.openModal()
    }
  }
}
</script>

<style scoped>
@media (max-width: 640px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
